/*
 * @Author: zhang lin
 * @Date: 2022-04-08 20:11:34
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-23 09:51:42
 * @Description: file content
 */
import moment from 'moment';

export const formatDate = (date: number | string | undefined, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date || !moment(date).isValid()) return;

  return moment(date).format(format);
};

export const convertSecToHHmmss = (sec: number | string | undefined) => {
  const currentTime = moment.duration(sec, 'seconds');
  return moment({
    h: currentTime.hours(),
    m: currentTime.minutes(),
    s: currentTime.seconds(),
  }).format('HH小时mm分ss秒');
};

/**
 *将数据流转成文件下载
 * @param data 文件数据
 * @param fileName  生成的文件名称(名称+后缀)
 * @returns
 */
export const downloadFiles = (data: any, fileName: string) => {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
  );
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
